import type { LogLevel } from './logger';

// Default versionado en el repo: define el comportamiento de prod sin depender
// de variables de entorno externas. Es el unico punto a tocar al portar a otra app.
export const DEFAULT_LOG_LEVEL: LogLevel = 'warn';
